import { ref } from "vue"
import _signupStepsCommonProps from "../../foundation/js/configurations/_signupStepsCommonProps"
import SignupStepActions from "../../../../Features/Blocks/Newsletters/NewslettersSignup/SignupStepActions/SignupStepActions.vue"
import Tooltip from "../Tooltip/Tooltip.vue"
import { useInputMask } from "../../composables/use-input-mask.composable"
import formSettings from "../CustomForm/settings"

export default {
  name: "ContactStepOnboardingContent",
  props: _signupStepsCommonProps,
  components: {
    SignupStepActions,
    Tooltip,
  },
  setup(props) {
    const firstNameInput = ref(props.getNamedFieldInputData.firstname)
    const lastNameInput = ref(props.getNamedFieldInputData.lastname)
    const emailInput = ref(props.getNamedFieldInputData.email)
    const phoneInput = ref(props.getNamedFieldInputData.phone)
    const homeOwnerInput = ref(props.getNamedFieldInputData.homeOwner ?? undefined)
    const urgentAccountInput = ref(props.getNamedFieldInputData.urgentAccount ?? undefined)
    const cprInput = ref(props.getNamedFieldInputData.cpr)
    const postalCodeInput = ref(props.getNamedFieldInputData.postalCode)
    const { inputElement: cprInputElement, updateMaskedValue: updateCprMaskedValue } = useInputMask(formSettings.formats.cpr)

    const handleHomeOwnerInput = (bool) => {
      homeOwnerInput.value = bool ?? false
    }

    const handleUrgentAccountInput = (bool) => {
      urgentAccountInput.value = bool ?? false
    }

    const onCprBlur = (evt) => {
      cprInput.value = updateCprMaskedValue(evt)
    }

    return {
      firstNameInput,
      lastNameInput,
      emailInput,
      phoneInput,
      homeOwnerInput,
      cprInput,
      postalCodeInput,
      cprInputElement,
      onCprBlur,
      urgentAccountInput,
      handleHomeOwnerInput,
      handleUrgentAccountInput
    }
  },
}
